import React from 'react'
import Trustpilot from './trustpilot'
import Icon from '../../../atoms/icon'

interface Props {
  link: boolean
  businessId: string
  templateId: string
}

const PoweredByMojoTrustPilot: React.FC<Props> = (props): JSX.Element => {
  return (
    <div className='powered-by-mojo-trustpilot'>
      <div className='powered-by-mojo-trustpilot__container'>
        <div className='powered-by-mojo-trustpilot__partnership'>
          <Icon glyph='partnership' ariaLabel={'In partnership with Mojo'} />
        </div>
        <div className='powered-by-mojo-trustpilot__trustpilot-wrapper'>
          <Trustpilot options={props} />
        </div>
      </div>
    </div>
  )
}

export default PoweredByMojoTrustPilot
